<template>
  <v-container fluid grid-list-xl>
    <v-layout row wrap>
      <v-flex xs6>
        <v-textarea
          v-model="csv"
          label="CSV"
          auto-grow
          box
        ></v-textarea>
        <v-btn @click="convert">Convert</v-btn>
      </v-flex>
      <v-flex xs6>
        <VueJsonPrettyWrapper :data="json"></VueJsonPrettyWrapper>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import VueJsonPrettyWrapper from '@/components/VueJsonPrettyWrapper.vue'

// import Bus from '@/bus'
import ApiMixin from '@/mixins/api'
import AuthMixin from '@/mixins/auth'
import DisplayMixin from '@/mixins/display'
import StoreMixin from '@/store/mixin'

export default {
  mixins: [ApiMixin, AuthMixin, DisplayMixin, StoreMixin],

  components: {VueJsonPrettyWrapper},

  data: function () {
    return {
      csv: '',
      json: {}
    }
  },

  created () {
    if (!this.hasPermission('superuser')) {
      this.$store.commit('error', 'Access Denied')
      this.$router.go(-1)
    }
  },

  mounted () {
  },

  destroyed () {
  },

  computed: {
  },

  watch: {
  },

  methods: {
    convert: function () {
      let final = []
      let lines = this.csv.split('\n')
      let headers = lines[0].split(',')
      lines.shift()

      for (let line of lines) {
        let data = {}
        let datum = line.split(',')

        for (let i = 0; i < headers.length; i++) {
          data[headers[i]] = datum[i].trim()
        }

        final.push(data)
      }

      this.json = final
    }
  }
}
</script>

<style>
#decoded {
  height: 100%;
  resize: both;
  overflow: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/manage/utilities/ConvertCsv.vue